import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-downloading',
  templateUrl: './dialog-downloading.component.html',
  styleUrl: './dialog-downloading.component.scss'
})
export class DialogDownloadingComponent  {

  public _dialogRef = inject(MatDialogRef<DialogDownloadingComponent>);
   
}
